import React, { useState, useEffect } from "react";
import "./index.scss";
import { Button, Icon, Toast } from "antd-mobile";
import { queryDriverAntiepidemic } from "@/api";
import { createNonceStr, md5, getLocationSearch } from "@/utils/utils";
import Header from '@/components/header'
import request from "@/utils/request";

import qs from "qs";

const Gvc = (props) => {
  let { history, location } = props;
  // let arr = location.search.split("?");
  // let { token } = qs.parse(arr[1]);
  let token = getLocationSearch().token;
  console.log(token, "gvc");

  const handleGoProve = () => {
    // history.push(`/gvc/prove?token=${token}`);
    history.push(`/gvc/prove`);
  };
  const handleGoReport = () => {
    // history.push(`/gvc/report?token=${token}`);
    history.push(`/gvc/report`);
  };
  const handleGoPlace = () => {
    // history.push(`/gvc/report?token=${token}`);
    history.push(`/gvc/place`);
  };
  let [proveDes, setProveDes] =
    useState("还未上传新冠疫苗接种记录，请尽快上传");
  let [reportDes, setReportDes] = useState(
    "<p>请上传要求时间范围内的核酸报告</p>"
  );
  let [placeDes, setPlaceDes] = useState(
    "<p>请上传车内张贴场所码的图片</p>"
  );
  let [state, setState] = useState({});
  const timesDes = (num) => {
    return num == 3 ? "加强针" : `第${num}针`;
  };
  const initRequest = async () => {
    let appKey = "app_h5";
    let secret = "11dc72cf-88b0-46cd-91d7-b1a77fd69ee1";
    let timestamp = new Date().getTime();
    let random = createNonceStr();
    let tempStr = `appKey${appKey}secret${secret}timestamp${timestamp}random${random}token${token}`;
    let sign = md5(tempStr, 32).toString(16).toLocaleUpperCase();
    Toast.loading("loading...", 0, () => {}, true);
    const res = await request.get(
      queryDriverAntiepidemic,
      { token },
      {
        appKey: appKey,
        timestamp: timestamp,
        random: random,
        token: token,
        sign: sign,
      }
    );
    Toast.hide();
    if (res.data.data) {
      let {
        vaccineReviewStatus,
        nucleicAcidReviewStatus,
        vaccine,
        vaccineReviewContent,
        nucleicAcidReviewContent,
        nucleicAcidDate,
        placeCodeReviewStatus,
        placeCodeDate,
        placeCodeReviewContent
      } = res.data.data;
      setState(res.data.data);
      // if (vaccineReviewStatus == 0) {
      //   setProveDes(`已接种${timesDes(vaccine)}，后台审核中`);
      // }
      if (vaccineReviewStatus == 0 || vaccineReviewStatus == 1) {
        setProveDes(
          `已接种${timesDes(vaccine)}，如果已经接种${timesDes(
            +vaccine + 1
          )}，请尽快上传`
        );
      }
      if (vaccineReviewStatus == 2) {
        setProveDes(vaccineReviewContent);
      }
      if (nucleicAcidReviewStatus == 2) {
        setReportDes(`<p>${nucleicAcidReviewContent}</p>`);
      }
      if (placeCodeReviewStatus == 2) {
        setPlaceDes(`<p>${placeCodeReviewContent}</p>`);
      }
      if (nucleicAcidReviewStatus == 0 || nucleicAcidReviewStatus == 1) {
        setReportDes(
          `<p>已上传核酸检测报告，检测时间：${nucleicAcidDate}</p><p>如有新的检测报告，请上传</p>`
        );
      }
      if (placeCodeReviewStatus == 0 || placeCodeReviewStatus == 1) {
        setPlaceDes(
          `<p>已上传场所码，上传时间：${placeCodeDate}</p><p>如有变化，请重新上传</p>`
        );
      }
      // if (nucleicAcidReviewStatus == 0) {
      //   setReportDes(
      //     `<p>已上传核酸检测报告，检测时间：${nucleicAcidDate}</p><p>后台审核中</p>`
      //   );
      // }
    } else if (res.data.errorMsg) {
      Toast.offline(res.data.errorMsg);
    }
  };

  useEffect(() => {
    document.title = "防疫检测";
    initRequest();
  }, []);

  return (
    <div className="gvc_box">
      <Header tit='防疫检测'></Header>
      {state.vaccineReviewStatus != 2 && state.vaccine == 3 ? (
        <div className="info_card">
          <div className="title">新冠疫苗接种证明</div>
          <div className="content">已接种加强针，非常棒！</div>
        </div>
      ) : (
        <div className="info_card">
          <div className="title">新冠疫苗接种证明</div>
          <div className="content">{proveDes}</div>
          <div className="btn">
            {state.vaccineReviewStatus == 2 ? (
              <div className="error" onClick={handleGoProve}>
                审核未通过，请重新上传
                <Icon type="right" />
              </div>
            ) : (
              <Button type="primary" inline onClick={handleGoProve}>
                上传
              </Button>
            )}
          </div>
        </div>
      )}
      <div className="info_card">
        <div className="title">核酸检测报告</div>
        <div
          className="content"
          dangerouslySetInnerHTML={{ __html: reportDes }}
        ></div>
        <div className="btn">
          {state.nucleicAcidReviewStatus == 2 ? (
            <div className="error" onClick={handleGoReport}>
              审核未通过，请重新上传
              <Icon type="right" />
            </div>
          ) : (
            <Button type="primary" inline onClick={handleGoReport}>
              上传
            </Button>
          )}
        </div>
      </div>

      <div className="info_card">
        <div className="title">场所码</div>
        <div
          className="content"
          dangerouslySetInnerHTML={{ __html: placeDes }}
        ></div>
        <div className="btn">
          {state.placeCodeReviewStatus == 2 ? (
            <div className="error" onClick={handleGoPlace}>
              审核未通过，请重新上传
              <Icon type="right" />
            </div>
          ) : (
            <Button type="primary" inline onClick={handleGoPlace}>
              上传
            </Button>
          )}
        </div>
      </div>

    </div>
  );
};
export default Gvc;
